<template>
  <v-alert
    v-if="deferredPrompt"
    style="position: fixed; right: 20px; margin-right: auto; margin-left: auto; top:30px; max-width:300px;"
    class="ma-3"
    dense
    :class="{ 'alert-mobile': $mobileDetect.phone() || $mobileDetect.tablet()}"
    transition="slide-y-reverse-transition"
  >
    <v-row
      align="center"
      no-gutters
    >
      <v-col
        cols="12"
        class="grow text-center"
      >
        {{ $t('pwa.askIfUserWant') }}
      </v-col>
      <v-col
        cols="12"
        class="text-center d-flex justify-space-around"
      >
        <v-btn
          icon
          color="white"
          large
          @click="acceptInstall"
        >
          <v-icon large>
            far fa-check-circle
          </v-icon>
        </v-btn>
        <v-btn
          icon
          color="white"
          large
          @click="refuseInstall"
        >
          <v-icon large>
            far fa-times-circle
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>
<script>
  export default {
    name: 'DialogPwa',
    data () {
      return {
        deferredPrompt: null,
      }
    },
    created () {
      window.addEventListener('beforeinstallprompt', e => {
        e.preventDefault()
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e
      })
      window.addEventListener('appinstalled', () => {
        this.deferredPrompt = false
      })
    },
    methods: {
      async acceptInstall () {
        this.deferredPrompt.prompt()
      },
      async refuseInstall () {
        this.deferredPrompt = false
      },
    },
  }
</script>
<style scoped>
.v-alert {
  z-index: 10!important;
  max-width: 900px;
  height: auto;
  margin: 0 auto !important;
  background-color: rgba(51, 139, 198, 0.705) !important;
  font-size: 20px;
  color: white;
  font-weight: bold;
}

.alert-mobile {
  right: 10px!important;
  left: 10px!important;
}
</style>
